'use client';

import { useSyncExternalStore } from 'react';
import { GoogleOneTap } from '@clerk/nextjs';

// Hydration gate, matching the auth pages: false on the server and the
// first client render, true afterward.
const subscribeToHydration = () => () => undefined;
const getHydratedSnapshot = () => true;
const getServerSnapshot = () => false;

// Where Clerk sends the user after One Tap authenticates
// them: an existing account to the sign-in target, a newly
// created one to the sign-up target.
// Docs:
//   https://clerk.com/docs/nextjs/reference/components/authentication/google-one-tap
interface GoogleOneTapPromptProps {
  signInRedirectUrl: string;
  signUpRedirectUrl: string;
}
export function GoogleOneTapPrompt({
  signInRedirectUrl,
  signUpRedirectUrl
}: GoogleOneTapPromptProps) {
  // Client-only. One Tap is a client widget; rendering it during SSR/
  // hydration adds a container div the auth page's server-rendered
  // loading skeleton has no counterpart for, tripping a hydration
  // mismatch. Gate on hydration so it mounts only on the client.
  const hasHydrated = useSyncExternalStore(subscribeToHydration, getHydratedSnapshot, getServerSnapshot);
  if (!hasHydrated) return null;
  return <GoogleOneTap signInForceRedirectUrl={signInRedirectUrl} signUpForceRedirectUrl={signUpRedirectUrl} data-sentry-element="GoogleOneTap" data-sentry-component="GoogleOneTapPrompt" data-sentry-source-file="google-one-tap-prompt.tsx" />;
}